export default "<div class=\"blue\">\n    <div class=\"white\">\n        <app-player-list></app-player-list>\n    </div>\n</div>";